export function defineThisScopeBinding( _this, _$scope, keys ) {

    keys.forEach( key => {

        Object.defineProperty( _$scope, key, {

            get: () => _this[ key ],
            set: value => _this[ key ] = value

        });
    });
}

export function buildUibComponentModal( name, component, componentOpts = {}, uibOpts = {} ) {

    let selector = component.selector;

    return {
        name,

        template: component.template,
        controller: component,

        asUibModal: ( attributes = {} ) => {
            let attributes_str = Object.keys( attributes ).map( key => `${ key }='${ key }'`).join( ' ' ).trim();
            return {
                windowClass: `${ selector }-modal`,
                template: `<${ selector } ${ attributes_str }></${ selector }>`,
                controller: ['$scope', function( $scope ) {
                    for (let key in attributes) {
                        $scope[key] = attributes[key];
                    }
                }],

                ...uibOpts
            };
        }, 

        ...componentOpts
    };
}

export function elementToModalRef( element ) {
    return {
        hide: () => {
            try {
                angular.element( element ).parent().scope().$parent.$close( );
                return;
            } catch (error) { }  
            debugger;
        }
    }
}